import { Popover, Tooltip } from '@mui/material';
import play_icon from '../../assets/images/play_icon.svg';
import { IOSSwitch } from '../../components/IOSSwitch';
import lightbulb_icon from '../../assets/images/lightbulb_icon.svg';
import { StakeKeypad } from './StakeKeypad';
import filter_icon from '../../assets/images/filter_icon.svg';
import { useState } from 'react';

export const MobileArbitrageButtons = (props) => {
	const {
		setRefreshCounter,
		setIsFiltersOpen,
		setIsLoading,
		refreshCounter,
		isScannable,
		setIsAutoRefresh,
		isAutoRefresh,
		setIsLive,
		isLive,
		setIsPlacedAnchorEl,
		setIsPlacedUnplacedOpen,
		isPlacedUnplacedOpen,
		setAllBetsOpen,
		allBetsOpen,
		isPlacedAnchorEl,
		globalStake,
		setGlobalStake,
		isFiltersOpen,
	} = props;

	const [isStakeKeypadOpen, setIsStakeKeypadOpen] = useState(false);

	return (
		<div className="mobile-arbitrage-container">
			{/* Top row: Pregame/Live, All Bets, Customize */}
			<div className="mobile-arbitrage-top-row">
				{/* Pregame/Live Toggle */}
				<div className="flex flex-row rounded-xl filter-button2 mobile-arbitrage-pregame-live-toggle">
					<div 
						onClick={() => setIsLive(false)} 
						className={`mobile-arbitrage-toggle-option ${!isLive && 'filter-button-highlighted'}`}>
						Pregame
					</div>
					<div
						onClick={() => setIsLive(true)}
						className={`mobile-arbitrage-toggle-option ${isLive && 'filter-button-highlighted'}`}>
						Live
					</div>
				</div>

				{/* All Bets Dropdown */}
				<div
					onClick={(e) => {
						setIsPlacedAnchorEl(e.currentTarget);
						setIsPlacedUnplacedOpen(!isPlacedUnplacedOpen);
					}}
					className="flex flex-row mobile-arbitrage-all-bets-button"
					style={{ 
						borderBottomLeftRadius: isPlacedUnplacedOpen ? 0 : '0.75rem',
						borderBottomRightRadius: isPlacedUnplacedOpen ? 0 : '0.75rem',
					}}>
					<img width={16} src={lightbulb_icon} alt="icon" className="mobile-arbitrage-icon" />
					<div className="mobile-arbitrage-all-bets-text">
						{allBetsOpen === 'all' && 'All'}
						{allBetsOpen === 'unplaced' && 'Unplaced'}
						{allBetsOpen === 'placed' && 'Placed'}
					</div>
				</div>

				<Popover
					anchorEl={isPlacedAnchorEl}
					open={isPlacedUnplacedOpen}
					onClose={() => {
						setIsPlacedUnplacedOpen(false);
					}}
					sx={{
						'& .MuiPaper-root': {
							backgroundColor: '#22262e',
							borderTopRightRadius: '0.75rem',
							borderBottomLeftRadius: '0.75rem',
							borderBottomRightRadius: '0.75rem',
							boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
						},
					}}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
					transformOrigin={{ vertical: 'top', horizontal: 'center' }}>
					<div className="mobile-arbitrage-dropdown" style={{ width: 120 }}>
						<div
							onClick={() => {
								setAllBetsOpen('all');
								setIsPlacedUnplacedOpen(false);
							}}
							className={`mobile-arbitrage-dropdown-item ${allBetsOpen === 'all' && 'filter-button-highlighted'}`}>
							All Bets
						</div>
						<div
							onClick={() => {
								setAllBetsOpen('unplaced');
								setIsPlacedUnplacedOpen(false);
							}}
							className={`mobile-arbitrage-dropdown-item ${allBetsOpen === 'unplaced' && 'filter-button-highlighted'}`}>
							Unplaced
						</div>
						<div
							onClick={() => {
								setAllBetsOpen('placed');
								setIsPlacedUnplacedOpen(false);
							}}
							className={`mobile-arbitrage-dropdown-item ${allBetsOpen === 'placed' && 'filter-button-highlighted'}`}>
							Placed
						</div>
					</div>
				</Popover>

				{/* Customize Button */}
				<div
					onClick={() => {
						setIsFiltersOpen(!isFiltersOpen);
					}}
					className={`filter-button rounded-xl cursor-pointer flex flex-row mobile-arbitrage-customize-button ${isFiltersOpen && 'filter-button-highlighted'} filter-button-tutorial`}>
					<img src={filter_icon} alt="filter icon" style={{ width: 16, height: 16, marginRight: '6px' }} />
					<div className="mobile-arbitrage-customize-text">Customize</div>
				</div>
			</div>

			{/* Second row: Scan, Auto Refresh, and Stake Input */}
			<div className="mobile-arbitrage-bottom-row">
				{/* Left side controls - Scan and Auto Refresh */}
				<div className="mobile-arbitrage-controls-left">
					{/* Scan button */}
					<Tooltip title={!isScannable ? `Finish selecting filters. At least one sportsbook must be selected.` : ''}>
						<button
							onClick={async () => {
								if (isScannable) {
									setRefreshCounter(refreshCounter + 1);
									setIsFiltersOpen(false);
									setIsLoading(true);
								}
							}}
							className={`mobile-arbitrage-scan-button ${!isScannable ? 'disabled' : ''}`}
							disabled={!isScannable}>
							<span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
								<img src={play_icon} alt="play icon" style={{ width: 18, height: 18, marginRight: '8px' }} />
								<span>Scan</span>
							</span>
						</button>
					</Tooltip>
					<button
						onClick={() => setIsAutoRefresh(!isAutoRefresh)}
						className={`mobile-arbitrage-auto-refresh-button ${isAutoRefresh ? 'active' : ''}`}>
						Auto Refresh
					</button>
				</div>

				{/* Right side controls - Stake Button */}
				<div className="mobile-arbitrage-controls-right">
					{/* Stake Button */}
					<div
						onClick={() => {
							setIsStakeKeypadOpen(true);
						}}
						className="flex flex-row filter-button cursor-pointer mobile-arbitrage-stake-button">
						<div style={{ fontSize: '12px', fontWeight: '500', color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.1' }}>
							Stake: ${Number(globalStake) > 0 ? Number(globalStake).toFixed(0) : globalStake}
						</div>
					</div>
				</div>
			</div>

			{/* Stake Keypad */}
			{isStakeKeypadOpen && (
				<StakeKeypad
					label="Default Stake"
					value={globalStake || 50}
					onChange={(val) => {
						setGlobalStake(val);
					}}
					onClose={() => setIsStakeKeypadOpen(false)}
				/>
			)}
		</div>
	);
};
